<template>
  <div>
    <div class="ui form" ref="form">
      <div class="field">
        <label>{{ $t("start in") }}</label>
        <div class="ui selection dropdown" ref="start_element_dropdown">
          <input type="hidden" name="start_element" />
          <i class="dropdown icon"></i>
          <div class="default text">{{ $t("start point") }}</div>
          <div class="menu"></div>
        </div>
      </div>
      <div class="field">
        <label for>{{ $t("payload") }}</label>
        <editor @init="init_editor" v-model="payload" lang="json" theme="monokai"></editor>
      </div>
      <div class="ui fluid blue button" @click="send_test">
        <i class="check icon"></i>
        {{ $t("test") }}
      </div>
    </div>
  </div>
</template>

<script>
import Editor from "vue2-ace-editor";
import { local_api, error_toast } from "@/utils";

export default {
  name: "TestManager",
  components: { Editor },
  props: { process: Object },
  data() {
    return {
      start_element: "",
      payload: "",
      form: null
    };
  },
  mounted() {
    this.form = window.jQuery(this.$refs.form).form({
      fields: {
        start_element: ["empty"]
      }
    });
  },
  methods: {
    init_editor() {
      require("brace/mode/json");
      require("brace/theme/monokai");
    },
    send_test() {
      let vm = this;
      let isValid = vm.form.form("validate form");

      if (isValid) {
        local_api(vm, "post", "/ngine_core/process/do-test", {
          p: vm.process.uuid,
          e: vm.start_element,
          l: vm.payload
        })
          .then(test => {
            vm.$alertify.success(vm.$t("instance created successfully"));
            console.log(test);
          })
          .catch(err => {
            error_toast(err);
          });
      }
    }
  },
  watch: {
    process() {
      let vm = this;
      let startableElements = ["bpmn:StartEvent", "bpmn:UserTask"];
      let vls = vm.process.definitions
        .filter(n => startableElements.includes(n.$type))
        .map(d => {
          return {
            name: d.name || d.$type,
            value: d.id,
            icon: "tasks"
          };
        });
      window
        .jQuery(vm.$refs.start_element_dropdown)
        .dropdown("setup menu", { values: vls })
        .dropdown({
          onChange(value) {
            vm.start_element = value;
          }
        });
    }
  }
};
</script>
